'use strict';


import webix from "./webix_clean.js";

global.webix = webix;

export { webix };

export default webix;
